import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { FieldArray, Form, Formik, Field } from "formik"
import { useEffect, useState } from "react"
import { getClassName } from "../../../utils"
import { TextareaAutosize } from "@mui/material"
import { AddMore } from "../../../components/Buttons/AddMoreButton"
import { StepperButtons } from "../../../components/Stepper/Buttons"
import { useNavigate } from "react-router-dom"
import { getTrendsForm } from "../../../services/autofillService"
import { Step } from "../../../components/Step/Step"
import { questions, videos } from "../../../content/relationships/trends"
import { useDispatch } from "react-redux"
import { setProgress } from "../../../store/progressSlice"
import { ProgressLine } from "../../../components/Progress/Line"
import { submitTrends } from "../../../services/answersService"

export const RelationshipsTrends = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [initialValues, setInitialValues] = useState({
        trends: [
            {
                trend: '',
            },
            {
                trend: '',
            },
            {
                trend: '',
            },
            {
                trend: '',
            },
            {
                trend: '',
            },
        ]
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showNext, setShowNext] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        submitTrends(values).then(response => {
            setIsLoading(false);
            // navigate("/flow/positioning");
            navigate("/flow/purpose/statement");
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        })
    }

    useEffect(() => {
        dispatch(setProgress(97))
        getTrendsForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
                setShowNext(true);
            }
        }).catch(err => {
            console.error(err);
        })
    }, [])
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                            <section className="flex flex-col items-center justify-center w-full h-full">
                                <Step className={getClassName(0, activeStep)} url={videos.trendsVideo.url} question={questions.trends}>
                                    <FieldArray name="trends">
                                        {({ insert, remove, push }) => (
                                            <>
                                                {values.trends.length > 0 &&
                                                    values.trends.map((trend, index) => (
                                                        <Field
                                                            name={`trends.${index}.trend`}
                                                            placeholder="Market Trend"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                            as={TextareaAutosize}
                                                        />
                                                    ))}
                                                <AddMore onClick={() => push({ trend: '' })} />
                                            </>
                                        )}
                                    </FieldArray>
                                </Step>
                            </section>
                            <section className="flex w-full items-center mb-[10%] justify-between z-10">
                                <StepperButtons
                                    link="/flow/relationships/competition"
                                    isLoading={isLoading}
                                    showNext={showNext || activeStep === 0}
                                />
                            </section>
                        </Form>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Relationships" />
        </>
    )
}